import { useState, useEffect, useRef } from "react"
import "./styles.scss"
import Btn from "../Btn"

const Index = () => {

    const data = [
        {
            id: 1,
            name: "BOGOTÁ",
            dir: "Calle 21 # 69B - 94, Zona industrial Montevideo",
            Detalles: "Más detalles",
            url_map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3976.6738177326033!2d-74.12233278573677!3d4.65213654337333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f9b8b94b727d7%3A0x452bdca6e89677c1!2sCl.%2021%20%2369b-94%2C%20Bogot%C3%A1!5e0!3m2!1ses-419!2sco!4v1633278403027!5m2!1ses-419!2sco",
            tels: []
        },
        {
            id: 2,
            name: "ITAGUI",
            dir: "Carrera 43 # 50 - 69, oficina 209",
            Detalles: "Estos son detalles",
            url_map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.721212463403!2d-75.60934428573432!3d6.1680744289054745!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e468232c69bba35%3A0xe1ee053e5be801cc!2sCra.%2043%20%2350-69%2C%20Itag%C3%BCi%2C%20Antioquia!5e0!3m2!1ses-419!2sco!4v1633278562757!5m2!1ses-419!2sco",
            tels: ["2812333"]
        },
        {
            id: 3,
            name: "CARTAGENA",
            dir: "Transversal 44 # 21 - 35, oficina 301, Edificio Empresarial Bosque",
            Detalles: "Estos son detalles",
            url_map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3924.246520400441!2d-75.52328658571548!3d10.40198486883885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8ef6258c62d5ef0d%3A0x8e4a47dc90d56645!2sTv.%2044%20%2321-35%2C%20Cartagena%2C%20Provincia%20de%20Cartagena%2C%20Bol%C3%ADvar!5e0!3m2!1ses-419!2sco!4v1633278630309!5m2!1ses-419!2sco",
            tels: ["6931985"]
        }, {
            id: 4,
            name: "BUENAVENTURA",
            dir: "Calle 7 # 4-22, oficina 205",
            Detalles: "Estos son detalles",
            url_map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1673.647400679509!2d-77.07576926323698!3d3.8898988092257194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e37238bc9ada0fd%3A0x76425031d56fc043!2sCl.%207%20%234-22%2C%20Buenaventura%2C%20Valle%20del%20Cauca!5e0!3m2!1ses-419!2sco!4v1633292404084!5m2!1ses-419!2sco",
            tels: []
        },
    ]
    const [actData, setActData] = useState(data[0]);
    const [contMap, setContMap] = useState({
        height: "10",
        width: "100%"
    })
    const uf_cont_map = useRef(null)

    useEffect(() => {
        setContMap({
            height: uf_cont_map.current.offsetHeight,
        })
    }, [])

    const cambiar_oficina = (element) => {
        const oficina = data.find(e => e.id == parseInt(element.target.name))
        setActData(oficina)
    }

    return (
        <section className="oficinas">
            {actData ? <>
                <div className="lista_oficinas">
                    <ul>
                        {
                            data.map((e, i) => {
                                return <li>
                                    <Btn key={i} type={"btn_3"} nombre={e.id} funOnclick={cambiar_oficina}>
                                        {e.name}
                                    </Btn>
                                </li>
                            })
                        }
                    </ul>
                </div>
                <div className="oficina_card">
                    <div className="titulo_oficina row">
                        <div className="nombre_oficina col-5">
                            <h2>{actData.name}</h2>
                            <div className="opciones_oficina">
                                <Btn type={"btn_email"} funOnclick={()=>{
                                    window.open(`/contacto`);
                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                        width="32" height="32"
                                        viewBox="0 0 172 172"
                                        style={{ fill: "#000000" }}><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M32.25,26.875c-11.81067,0 -21.5,9.68933 -21.5,21.5v80.625c0,8.84171 7.28329,16.125 16.125,16.125h26.875v-53.58203l32.25,24.30298l32.25,-24.30298v53.58203h26.875c8.84171,0 16.125,-7.28329 16.125,-16.125v-80.625c0,-11.81067 -9.68933,-21.5 -21.5,-21.5c-4.82069,0 -9.3356,1.59993 -12.94409,4.2937l-0.0105,0.0105l-40.79541,30.72778l-40.78491,-30.72778v0.0105c-3.62222,-2.73469 -8.15282,-4.3147 -12.96509,-4.3147zM32.25,37.625c2.47623,0 4.71351,0.80206 6.48779,2.1416l4.26221,3.2124v27.00097l-21.5,-16.19849v-5.40649c0,-6.00208 4.74792,-10.75 10.75,-10.75zM139.75,37.625c6.00208,0 10.75,4.74792 10.75,10.75v5.39599l-21.5,16.19849v-27.00098l4.24121,-3.19141c1.77726,-1.32673 4.09473,-2.1521 6.50879,-2.1521zM53.75,51.073l32.25,24.29248l32.25,-24.29248v27.00098l-32.25,24.30298l-32.25,-24.30298zM21.5,67.22949l21.5,16.20899v50.93652h-16.125c-3.03704,0 -5.375,-2.33796 -5.375,-5.375zM150.5,67.22949v61.77051c0,3.03704 -2.33796,5.375 -5.375,5.375h-16.125v-50.93652z"></path></g></g></svg>
                                    E-mail
                                </Btn>
                                <Btn type={"btn_whatapp"} funOnclick={()=>{
                                    window.open(`https://api.whatsapp.com/send?phone=573104477161&text=Hola! me llamo `);
                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                        width="32" height="32"
                                        viewBox="0 0 172 172"
                                        style={{ fill: "#000000" }}><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M86.08399,14.33333c-39.45967,0 -71.58235,32.09502 -71.59668,71.55469c-0.00717,12.61333 3.29655,24.92701 9.56022,35.77734l-9.71419,36.00131l37.49902,-8.86035c10.45617,5.70467 22.22697,8.69922 34.20963,8.70638h0.028c39.4525,0 71.56118,-32.10219 71.58268,-71.55469c0.01433,-19.12784 -7.42377,-37.11191 -20.9401,-50.64258c-13.51633,-13.5235 -31.47925,-20.97493 -50.62858,-20.9821zM86.06999,28.66667c15.308,0.00717 29.69396,5.97554 40.50846,16.78288c10.8145,10.82167 16.75522,25.2008 16.74089,40.49447c-0.01433,31.56199 -25.68702,57.23535 -57.26335,57.23535c-9.55317,-0.00717 -19.01607,-2.40588 -27.35091,-6.95671l-4.8291,-2.63151l-5.33301,1.25976l-14.10937,3.33138l3.44336,-12.79362l1.55371,-5.73894l-2.96745,-5.15104c-5.00233,-8.65733 -7.64974,-18.55584 -7.64258,-28.61067c0.01433,-31.54767 25.69452,-57.22135 57.24935,-57.22135zM60.7487,52.85417c-1.19683,0 -3.13195,0.44792 -4.77311,2.23958c-1.64117,1.7845 -6.27083,6.10656 -6.27083,14.90723c0,8.80067 6.41081,17.30772 7.30664,18.50455c0.88867,1.18967 12.37448,19.82031 30.55632,26.98698c15.10733,5.9555 18.17568,4.78017 21.45801,4.47917c3.28233,-0.29383 10.58909,-4.31825 12.07975,-8.49641c1.49066,-4.17817 1.49414,-7.77226 1.0498,-8.51042c-0.44433,-0.74533 -1.6377,-1.18978 -3.42936,-2.08561c-1.7845,-0.89583 -10.57856,-5.21409 -12.21973,-5.80892c-1.64117,-0.59483 -2.84158,-0.89583 -4.03125,0.89583c-1.18967,1.79167 -4.60861,5.80903 -5.65494,6.9987c-1.04633,1.19683 -2.08561,1.35775 -3.87728,0.46191c-1.79167,-0.903 -7.55232,-2.79668 -14.38932,-8.88835c-5.31767,-4.73717 -8.90582,-10.58203 -9.95215,-12.37369c-1.03917,-1.7845 -0.09798,-2.76466 0.79785,-3.65332c0.80267,-0.80267 1.77767,-2.08908 2.6735,-3.13542c0.88867,-1.04633 1.19683,-1.79178 1.79167,-2.98145c0.59483,-1.18966 0.29036,-2.23958 -0.15398,-3.13541c-0.44433,-0.89583 -3.92397,-9.7292 -5.51497,-13.26953c-1.34017,-2.97417 -2.75558,-3.04326 -4.03125,-3.09342c-1.03917,-0.043 -2.2257,-0.04199 -3.41536,-0.04199z"></path></g></g></svg>
                                    Chatear
                                </Btn>
                            </div>
                        </div>
                        <div className="info_oficina col">
                            <h5>Dirección:</h5>
                            <p>{actData.dir}</p>
                            <h5>Teléfonos</h5>
                            <ul>
                                {
                                    actData.tels.map((e, i) => {
                                        return <li>
                                            {e}
                                        </li>
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="ubicacion_oficina" ref={uf_cont_map}>
                        {uf_cont_map ?
                            <iframe src={actData.url_map}
                                width={"100%"}
                                height={contMap.height}
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy">
                            </iframe> : ""}
                    </div>
                </div>
            </> : ""}
        </section>
    )
}

export default Index